import React from 'react';
import styled from 'styled-components';
import { Row, Col } from "reactstrap";
import { OutputRow, TableIcon, BoldLabel } from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";
import SubtotalColumns from "../../experiences/cost-summary/subtotal-cols";
import { displayValue } from '../../helper';
import { calculateRebelContingency } from '../../experiences/cost-summary/cost-helper';

const RebelContingencyRow = ({guideData, expData}) => {
    const attendees = parseFloat(guideData.attendees?.value) || 1;
    const contingencyTotal = calculateRebelContingency(guideData, expData);

    return(
        <React.Fragment>
            <RebelNoBorderRow>
                <Col lg="1"/>
                <Col>
                    <Row>
                        <Col sm={{size: 'auto'}}>
                            <TableIcon icon={['fas', 'shield-alt']}/>
                        </Col>
                        <Col>
                        <BoldLabel>
                            Contingency
                        </BoldLabel>
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <RebelText>({guideData.contingency.value}%)</RebelText>
                </Col>
                <Col lg="2">
                    <RebelText>{guideData.currency.value.slice(3)}{displayValue(contingencyTotal / attendees)}</RebelText>
                </Col>
                <Col lg="1">
                </Col>
                <Col lg="2">
                    <RebelText>
                        {guideData.currency.value.slice(3)}{displayValue(contingencyTotal)}
                    </RebelText>
                </Col>
            </RebelNoBorderRow>
        </React.Fragment>
    )
}

export default RebelContingencyRow;

const RebelNoBorderRow = styled(OutputRow).attrs({
    className: 'rebel-no-border'
})`
    && {
        border-bottom: none !important;
    }
`;

const RebelText = styled.p`
    color: ${RebelColors.text};
`;
